import { gql } from '@grandvisionhq/graphql';

const GET_CART_PAYMENT_METHODS = gql`
  query CartPaymentMethods($cartId: ID!) {
    cartPaymentMethods(cartId: $cartId) {
      psp
      name
      issuers {
        id
        name
      }
      brands
      installmentTypes {
        id
        installments
      }
      donations {
        brands
        options
        key
      }
    }
  }
`;

export { GET_CART_PAYMENT_METHODS };
//# sourceMappingURL=get-cart-payment-methods.js.map
